import React from 'react';


const Footer = ({text, includeDefault}) => {
  return (
    <div className='row page-footer'>
      <div className='large-12 columns'>
        <div className='footer-text-container'>
          <h2>Join Cureus</h2>
          {includeDefault && 
          (
            <p>
            Sign up for Cureus today and help revolutionize medical research through <a href='/about_publishing'>quick and affordable publishing</a>, <a href='/cureus_editing_services'>expert editing</a>, robust <a href='/reviewer_guide'>peer review</a> processes, and global exposure.
            </p>
          )}
          
          <div>{text}</div>
        </div>
        <div className='footer-btn-container'>
          <div className='btn-wrapper'>
            <div>
              <a href='/about' className='button primary btn-text'>Learn More about Cureus</a>
            </div>
            <div>
              <a href='/registrations/sign_up' className='button primary btn-text'>Join Now</a>
            </div>
            <div>
              <a href='/contact' className='button primary btn-text'>Contact Us</a>
            </div>   
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer;